import { heydayPath, navigateToHeydayPage, pageFromPathname, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type { OrganizationStudioRoutePort } from '../../features/organization/public';

function readPlanId() {
  if (pageFromPathname(window.location.pathname) !== 'organization') return undefined;
  const query = new URLSearchParams(window.location.search);
  return query.get('planId')?.trim() || query.get('studio')?.trim() || undefined;
}
function readView(): 'general' | 'studio' {
  return new URLSearchParams(window.location.search).get('view') === 'general' ? 'general' : 'studio';
}
let initialContextLocation: string | undefined;
let initialContext: ReturnType<NonNullable<OrganizationStudioRoutePort['readInitialContext']>>;
function readInitialContext() {
  const location = `${window.location.pathname}${window.location.search}`;
  if (initialContextLocation === location) return initialContext;
  initialContextLocation = location;
  initialContext = undefined;
  if (readPlanId() !== 'new') return undefined;
  const query = new URLSearchParams(window.location.search);
  const workerId = query.get('worker')?.trim();
  if (!workerId) return undefined;
  const effectiveDate = query.get('effectiveDate')?.trim() ?? '';
  initialContext = {
    workerId, organizationId: query.get('organization')?.trim() || undefined,
    effectiveDate: /^\d{4}-\d{2}-\d{2}$/.test(effectiveDate) ? effectiveDate : undefined,
  };
  return initialContext;
}
function replaceEditorLocation(planId: string, view: 'general' | 'studio') {
  if (!readPlanId() || !planId.trim()) return;
  // 같은 발령안 안의 보기 전환과 저장 ID 반영은 편집 세션을 유지합니다.
  const next = heydayPath('organization', new URLSearchParams({ planId, view }));
  if (next === `${window.location.pathname}${window.location.search}`) return;
  window.history.replaceState(window.history.state, '', next);
  window.dispatchEvent(new Event('heyday:location-change'));
}

export const organizationStudioRouteAdapter: OrganizationStudioRoutePort = {
  read: readPlanId,
  readView,
  readInitialContext,
  open: (planId, view = 'studio') => {
    if (pageFromPathname(window.location.pathname) === 'organization') navigateToHeydayPage('organization', new URLSearchParams({ planId, view }));
  },
  replace: (planId) => replaceEditorLocation(planId, readView()),
  setView: (view) => { const planId = readPlanId(); if (planId) replaceEditorLocation(planId, view); },
  close: () => { if (pageFromPathname(window.location.pathname) === 'organization') navigateToHeydayPage('organization', '', { replace: true }); },
  subscribe: subscribeToHeydayLocation,
};
